'use strict';

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for email sign-up
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status;
    var container = button.parents('.email-container');
    if (!container.length) container = $(window);

    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
        $('form.email-signup input:visible', container).first().focus();
        if (!data.msg) {
            data.msg = 'Email signup could not be completed at this time. Please try again later.';
        }
    }

    if (!$('.email-signup-message', container).length) {
        $('.subscription-handlers', container).append(
            '<div class="email-signup-message"></div>'
        );
    }
    $('.email-signup-message', container)
        .append('<div class="email-signup-alert alert ' + status + ' alert-dismissible fade show" role="alert">'
            + data.msg
            + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
            + '<span aria-hidden="true">&times;</span></button>'
            + '</div>');

    // set tabindex and focus
    $('.email-signup-alert', container)
        .attr('tabindex', 0)
        .focus()
        .on('closed.bs.alert', function () {
            $('.email-signup-message', container).remove();
            button.removeAttr('disabled');
        });
}

module.exports = function () {
    $('form.email-signup').on('submit', function (e) {
        e.preventDefault();
        $.spinner().start();
        var form = $(this);
        var button = $('.subscribe-email', form);
        var emailAddress = form.find('[name=dwfrm_mcsubscribe_email]').val();
        $.ajax({
            url: form.data('action'),
            type: 'post',
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
                displayMessage(data, button);

                $(document).trigger('email-sign-up', {
                    emailAddress: emailAddress,
                    hashedEmail: data.hashedEmail
                });
            },
            error: function (err) {
                displayMessage(err, button);
            }
        });
    });
};
